export default "__VITE_ASSET__EwsRqd1z__"